// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import Header from './Header';
// import { useCartDrawer } from './CartContext';
// import { toast } from 'react-toastify';

// const Checkout = () => {
//     const [formData, setFormData] = useState({
//         email: '',
//         firstName: '',
//         lastName: '',
//         phone: '',
//         address: '',
//         city: '',
//         region: '',
//         zip: ''
//     });

//     const [userId, setUserId] = useState(null);
//     const [cartData, setCartData] = useState([]);
//     const [customizeData2, setCustomizeData2] = useState([]);
//     const [subtotal, setSubtotal] = useState(0);
//     const { openCart } = useCartDrawer();

//     useEffect(() => {
//         const storedUser = JSON.parse(localStorage.getItem('user'));
//         if (storedUser) {
//             setUserId(storedUser.UserID);
//             setFormData(prev => ({
//                 ...prev,
//                 email: storedUser.Email || '',
//                 firstName: storedUser.First_Name || '',
//                 lastName: storedUser.Last_Name || ''
//             }));
//             fetchCartData(storedUser.UserID);
//         }

//         axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/viewcustomize`)
//             .then((res) => {
//                 setCustomizeData2(res.data.View_Customize || []);
//             })
//             .catch((err) => {
//                 console.error("Error fetching customize data:", err);
//             });
//     }, []);

//     const fetchCartData = async (UserID) => {
//         try {
//             const res = await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/getcartdetails`, {
//                 Customer_ID: UserID
//             });

//             const data = res.data?.AddToCartDetails || [];
//             setCartData(data);

//             const total = data.reduce((sum, item) => sum + (item.Quantity * item.Rate || 0), 0);
//             setSubtotal(total);

//         } catch (err) {
//             console.error("Error fetching cart data:", err);
//         }
//     };

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         const payload = {
//             UserID: userId,
//             Phone_Number: formData.phone,
//             Address: formData.address,
//             City: formData.city,
//             Region: formData.region,
//             Zip_Code: formData.zip,
//             First_Name: formData.firstName,
//             Last_Name: formData.lastName
//         };

//         try {
//             const response = await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/updateuserlogin`, payload);

//             if (response.data.message === 'success' || response.status === 200) {
//                 alert('User info updated successfully!');
//                 setFormData(prev => ({
//                     ...prev,
//                     phone: '',
//                     address: '',
//                     city: '',
//                     region: '',
//                     zip: ''
//                 }));
//             } else {
//                 alert('Something went wrong. Please try again.');
//             }
//         } catch (error) {
//             console.error('Error updating user info:', error);
//             alert('Failed to update user info');
//         }
//     };

//     const handleWhatsAppCheckout = () => {
//         if (!cartData || cartData.length === 0) {
//             toast.warn("Cart is empty!");
//             return;
//         }

//         const productsList = cartData.map(item => {
//             const customize = customizeData2?.[0]?.find(c => c.Product_Id === item.Product_Id);
//             let itemMessage = `────────────────────\n`;
//             itemMessage += `Product: ${item.Product_Name}\n`;
//             itemMessage += `Category: ${item.Category || 'N/A'}\n`;
//             itemMessage += `Subcategory: ${item.SubCategory || 'N/A'}\n`;
//             itemMessage += `Size: ${item.Size || 'Standard'}\n`;
//             itemMessage += `Quantity: ${item.Quantity}`;

//             if (customize) {
//                 if (customize.custom_description && customize.custom_description.trim() !== "") {
//                     itemMessage += `\nCustom Desc: ${customize.custom_description}`;
//                 }
//                 if (customize.custom_size && customize.custom_size.trim() !== "") {
//                     itemMessage += `\nCustom Size: ${customize.custom_size}`;
//                 }
//             }
//             return itemMessage;
//         }).join('\n\n');

//         const finalMessage = `Hello, I would like to order these products.\n\n${productsList}\n\n────────────────────\nThank you!`;
//         const encodedMessage = encodeURIComponent(finalMessage);
//         const whatsappUrl = `https://wa.me/917984785574?text=${encodedMessage}`;
//         window.open(whatsappUrl, "_blank");
//     };

//     const handlePlaceOrder = () => {
//         if (!cartData || cartData.length === 0) {
//             toast.warn("Cart is empty!");
//             return;
//         }

//         const user = JSON.parse(localStorage.getItem('user'));
//         const customerName = user ? `${user.First_Name} ${user.Last_Name}` : 'Guest';
//         const customerEmail = user?.Email || 'Not Provided';

//         let emailBody = `Hello,%0D%0A%0D%0ANew Order Details:%0D%0A%0D%0A`;
//         emailBody += `Customer Name: ${customerName}%0D%0A`;
//         emailBody += `Customer Email: ${customerEmail}%0D%0A`;
//         emailBody += `════════════════════════════════%0D%0A%0D%0A`;
//         emailBody += `ORDER ITEMS:%0D%0A`;

//         cartData.forEach((item, index) => {
//             const customize = customizeData2?.[0]?.find(c => c.Product_Id === item.Product_Id);
//             emailBody += `${index + 1}. Product: ${encodeURIComponent(item.Product_Name)}%0D%0A`;
//             emailBody += `   Category: ${encodeURIComponent(item.Category || 'N/A')}%0D%0A`;
//             emailBody += `   Subcategory: ${encodeURIComponent(item.SubCategory || 'N/A')}%0D%0A`;
//             emailBody += `   Size: ${encodeURIComponent(item.Size || 'Standard')}%0D%0A`;
//             emailBody += `   Quantity: ${item.Quantity}%0D%0A`;

//             if (customize) {
//                 if (customize.custom_description && customize.custom_description.trim() !== "") {
//                     emailBody += `   Custom Description: ${encodeURIComponent(customize.custom_description)}%0D%0A`;
//                 }
//                 if (customize.custom_size && customize.custom_size.trim() !== "") {
//                     emailBody += `   Custom Size: ${encodeURIComponent(customize.custom_size)}%0D%0A`;
//                 }
//             }
//             emailBody += `%0D%0A──────────────────────────────%0D%0A%0D%0A`;
//         });

//         emailBody += `%0D%0AThank you for your order!%0D%0A%0D%0ABest regards,%0D%0AVV Design Studio`;
//         const subject = encodeURIComponent(`New Order from ${customerName} - VV Design Studio`);
//         const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=visputevibha.15@gmail.com&su=${subject}&body=${emailBody}`;
//         window.open(gmailUrl, '_blank');
//         toast.success("Gmail opened! Please review and send the email.");
//     };

//     return (
//         <>
//             <Header />
//             <div className="checkout-main">
//                 <div className="container">
//                     <div className="checkout-inner-main">
//                         {/* Left - Form Section */}
//                         <div className="checkout-child checkout-left">
//                             <div className="checkout-inner-child">
//                                 <h3 className='check-one'>Customer details</h3>
//                                 <form onSubmit={handleSubmit} className='check-form'>
//                                     <label className='check-label'>Email*</label>
//                                     <input
//                                         type="email"
//                                         name="email"
//                                         value={formData.email}
//                                         onChange={handleChange}
//                                         required
//                                         readOnly
//                                         className='check-input'
//                                         placeholder="user@example.com"
//                                     />

//                                     <div className="name-group">
//                                         <div>
//                                             <label className='check-label'>First Name*</label>
//                                             <input
//                                                 type="text"
//                                                 name="firstName"
//                                                 value={formData.firstName}
//                                                 onChange={handleChange}
//                                                 required
//                                                 className='check-input'
//                                                 placeholder="Enter first name"
//                                             />
//                                         </div>
//                                         <div>
//                                             <label className='check-label'>Last Name*</label>
//                                             <input
//                                                 type="text"
//                                                 name="lastName"
//                                                 value={formData.lastName}
//                                                 onChange={handleChange}
//                                                 required
//                                                 className='check-input'
//                                                 placeholder="Enter last name"
//                                             />
//                                         </div>
//                                     </div>

//                                     <label className='check-label'>Phone*</label>
//                                     <input
//                                         type="tel"
//                                         name="phone"
//                                         value={formData.phone}
//                                         onChange={handleChange}
//                                         required
//                                         className='check-input'
//                                         placeholder="+1 (000) 000-0000"
//                                     />

//                                     <h3 className='check-one delivery-title'>Delivery Details</h3>

//                                     <label className='check-label'>Address*</label>
//                                     <input
//                                         type="text"
//                                         name="address"
//                                         value={formData.address}
//                                         onChange={handleChange}
//                                         required
//                                         className='check-input'
//                                         placeholder="Street address"
//                                     />

//                                     <div className="name-group">
//                                         <div>
//                                             <label className='check-label'>City*</label>
//                                             <input
//                                                 type="text"
//                                                 name="city"
//                                                 value={formData.city}
//                                                 onChange={handleChange}
//                                                 required
//                                                 className='check-input'
//                                                 placeholder="City"
//                                             />
//                                         </div>
//                                         <div>
//                                             <label className='check-label'>Region*</label>
//                                             <input
//                                                 type="text"
//                                                 name="region"
//                                                 value={formData.region}
//                                                 onChange={handleChange}
//                                                 required
//                                                 className='check-input'
//                                                 placeholder="Region/State"
//                                             />
//                                         </div>
//                                     </div>

//                                     <label className='check-label'>Zip / Postal code*</label>
//                                     <input
//                                         type="text"
//                                         name="zip"
//                                         value={formData.zip}
//                                         onChange={handleChange}
//                                         required
//                                         className='check-input'
//                                         placeholder="000000"
//                                     />

//                                     <button type="submit" className="checkout-button">Continue to Shipment</button>
//                                 </form>
//                             </div>
//                         </div>

//                         {/* Right - Cart Summary - EXACT IMAGE DESIGN */}
//                         <div className="checkout-child checkout-right">
//                             <div className="order-summary-card">
//                                 <div className="summary-header-new">
//                                     <h3 className="summary-title">Items in your order ({cartData.length})</h3>
//                                     <button className="edit-cart-link" onClick={openCart}>Edit Cart</button>
//                                 </div>

//                                 {cartData.length === 0 ? (
//                                     <p className="empty-cart-msg">Your cart is empty.</p>
//                                 ) : (
//                                     <>
//                                         <div className="order-items-container">
//                                             {cartData.map((item, index) => (
//                                                 <div key={index} className="order-item-card">
//                                                     <img
//                                                         src={`${process.env.REACT_APP_IMAGE_BASE_URL}${item.Product_Img}`}
//                                                         alt={item.Product_Name}
//                                                         className="order-product-img"
//                                                     />
//                                                     <div className="order-product-info">
//                                                         <h4 className="product-title">{item.Product_Name}</h4>
//                                                         <p className="product-quantity">Quantity: {item.Quantity}</p>
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </div>

//                                         <div className="checkout-actions-container">
//                                             <button className="action-btn whatsapp-checkout-btn" onClick={handleWhatsAppCheckout}>
//                                                 Checkout to WhatsApp
//                                             </button>
//                                             <button className="action-btn place-order-checkout-btn" onClick={handlePlaceOrder}>
//                                                 Place Order
//                                             </button>
//                                         </div>

//                                         <div className="secure-protection">
//                                             <svg width="16" height="16" viewBox="0 0 24 24" fill="#ff9800" style={{ marginRight: '6px' }}>
//                                                 <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
//                                                 <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
//                                             </svg>
//                                             Secure Checkout Protection
//                                         </div>
//                                     </>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default Checkout;

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './Header';
import { useCartDrawer } from './CartContext';
import { toast } from 'react-toastify';

const Checkout = () => {
    const [formData, setFormData] = useState({
        email: '',
        firstName: '',
        lastName: '',
        phone: '',
        address: '',
        city: '',
        region: '',
        zip: ''
    });

    const [userId, setUserId] = useState(null);
    const [cartData, setCartData] = useState([]);
    const [customizeData2, setCustomizeData2] = useState([]);
    const [subtotal, setSubtotal] = useState(0);
    const { openCart } = useCartDrawer();

    useEffect(() => {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedUser) {
            setUserId(storedUser.UserID);
            setFormData(prev => ({
                ...prev,
                email: storedUser.Email || '',
                firstName: storedUser.First_Name || '',
                lastName: storedUser.Last_Name || ''
            }));
            fetchCartData(storedUser.UserID);
        }

        axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/viewcustomize`)
            .then((res) => {
                setCustomizeData2(res.data.View_Customize || []);
            })
            .catch((err) => {
                // console.error("Error fetching customize data:", err);
            });
    }, []);

    const fetchCartData = async (UserID) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/getcartdetails`, {
                Customer_ID: UserID
            });

            const data = res.data?.AddToCartDetails?.[0] || [];
            setCartData(data);

            const total = data.reduce((sum, item) => sum + (item.Quantity * item.Rate || 0), 0);
            setSubtotal(total);

        } catch (err) {
            // console.error("Error fetching cart data:", err);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     const payload = {
    //         UserID: userId,
    //         Phone_Number: formData.phone,
    //         Address: formData.address,
    //         City: formData.city,
    //         Region: formData.region,
    //         Zip_Code: formData.zip,
    //         First_Name: formData.firstName,
    //         Last_Name: formData.lastName
    //     };

    //     try {
    //         const response = await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/updateuserlogin`, payload);

    //         if (response.data.message === 'success' || response.status === 200) {
    //             toast.success('User info updated successfully!');
    //             setFormData(prev => ({
    //                 ...prev,
    //                 phone: '',
    //                 address: '',
    //                 city: '',
    //                 region: '',
    //                 zip: ''
    //             }));
    //         } else {
    //             toast.error('Something went wrong. Please try again.');
    //         }
    //     } catch (error) {
    //         console.error('Error updating user info:', error);
    //         toast.error('Failed to update user info');
    //     }
    // };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            UserID: userId,
            Phone_Number: formData.phone,
            Address: formData.address,
            City: formData.city,
            Region: formData.region,
            Zip_Code: formData.zip,
            First_Name: formData.firstName,
            Last_Name: formData.lastName
        };

        try {
            // First work: Update user info in database
            const response = await axios.post(`${process.env.REACT_APP_SECRET_KEY}/api/updateuserlogin`, payload);

            if (response.data.message === 'success' || response.status === 200) {
                toast.success('User info updated successfully!');

                // Second work: Send order email (same as Place Order button)
                handlePlaceOrder();

                // Clear form fields after both tasks complete
                setFormData(prev => ({
                    ...prev,
                    phone: '',
                    address: '',
                    city: '',
                    region: '',
                    zip: ''
                }));
            } else {
                toast.error('Something went wrong. Please try again.');
            }
        } catch (error) {
            // console.error('Error updating user info:', error);
            toast.error('Failed to update user info');
        }
    };


    const handleWhatsAppCheckout = () => {
        if (!cartData || cartData.length === 0) {
            toast.warn("Cart is empty!");
            return;
        }

        const productsList = cartData.map(item => {
            const customize = customizeData2?.[0]?.find(c => c.Product_Id === item.Product_Id);
            let itemMessage = `────────────────────\n`;
            itemMessage += `Product: ${item.Product_Name}\n`;
            itemMessage += `Category: ${item.Category || 'N/A'}\n`;
            itemMessage += `Subcategory: ${item.SubCategory || 'N/A'}\n`;
            itemMessage += `Size: ${item.Size || 'Standard'}\n`;
            itemMessage += `Quantity: ${item.Quantity}`;

            if (customize) {
                if (customize.custom_description && customize.custom_description.trim() !== "") {
                    itemMessage += `\nCustom Desc: ${customize.custom_description}`;
                }
                if (customize.custom_size && customize.custom_size.trim() !== "") {
                    itemMessage += `\nCustom Size: ${customize.custom_size}`;
                }
            }
            return itemMessage;
        }).join('\n\n');

        const finalMessage = `Hello, I would like to order these products.\n\n${productsList}\n\n────────────────────\nThank you!`;
        const encodedMessage = encodeURIComponent(finalMessage);
        const whatsappUrl = `https://wa.me/917984785574?text=${encodedMessage}`;
        window.open(whatsappUrl, "_blank");
    };

    const handlePlaceOrder = () => {
        if (!cartData || cartData.length === 0) {
            toast.warn("Cart is empty!");
            return;
        }

        const user = JSON.parse(localStorage.getItem('user'));
        const customerName = user ? `${user.First_Name} ${user.Last_Name}` : 'Guest';
        const customerEmail = user?.Email || 'Not Provided';

        let emailBody = `Hello,%0D%0A%0D%0ANew Order Details:%0D%0A%0D%0A`;
        emailBody += `Customer Name: ${customerName}%0D%0A`;
        emailBody += `Customer Email: ${customerEmail}%0D%0A`;
        emailBody += `════════════════════════════════%0D%0A%0D%0A`;
        emailBody += `ORDER ITEMS:%0D%0A`;

        cartData.forEach((item, index) => {
            const customize = customizeData2?.[0]?.find(c => c.Product_Id === item.Product_Id);
            emailBody += `${index + 1}. Product: ${encodeURIComponent(item.Product_Name)}%0D%0A`;
            emailBody += `   Category: ${encodeURIComponent(item.Category || 'N/A')}%0D%0A`;
            emailBody += `   Subcategory: ${encodeURIComponent(item.SubCategory || 'N/A')}%0D%0A`;
            emailBody += `   Size: ${encodeURIComponent(item.Size || 'Standard')}%0D%0A`;
            emailBody += `   Quantity: ${item.Quantity}%0D%0A`;

            if (customize) {
                if (customize.custom_description && customize.custom_description.trim() !== "") {
                    emailBody += `   Custom Description: ${encodeURIComponent(customize.custom_description)}%0D%0A`;
                }
                if (customize.custom_size && customize.custom_size.trim() !== "") {
                    emailBody += `   Custom Size: ${encodeURIComponent(customize.custom_size)}%0D%0A`;
                }
            }
            emailBody += `%0D%0A──────────────────────────────%0D%0A%0D%0A`;
        });

        emailBody += `%0D%0AThank you for your order!%0D%0A%0D%0ABest regards,%0D%0AVV Design Studio`;
        const subject = encodeURIComponent(`New Order from ${customerName} - VV Design Studio`);
        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=vvdesign.64@gmail.com&su=${subject}&body=${emailBody}`;
        window.open(gmailUrl, '_blank');
        toast.success("Gmail opened! Please review and send the email.");
    };

    return (
        <>
            <Header />
            <div className="checkout-main">
                <div className="container">
                    <div className="checkout-inner-main">
                        {/* Left - Form Section */}
                        <div className="checkout-child checkout-left">
                            <div className="checkout-inner-child">
                                <h3 className='check-one'>Customer Details</h3>
                                <form onSubmit={handleSubmit} className='check-form'>
                                    <label className='check-label'>Email*</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                        readOnly
                                        className='check-input'
                                        placeholder="user@example.com"
                                    />

                                    <div className="name-group">
                                        <div>
                                            <label className='check-label'>First Name*</label>
                                            <input
                                                type="text"
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                required
                                                readOnly
                                                className='check-input'
                                                placeholder="Enter first name"
                                            />
                                        </div>
                                        <div>
                                            <label className='check-label'>Last Name*</label>
                                            <input
                                                type="text"
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                required
                                                readOnly
                                                className='check-input'
                                                placeholder="Enter last name"
                                            />
                                        </div>
                                    </div>

                                    <label className='check-label'>Phone*</label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                        className='check-input'
                                        placeholder="+91 0000000000"
                                    />

                                    <h3 className='check-one delivery-title'>Delivery Details</h3>

                                    <label className='check-label'>Address*</label>
                                    <input
                                        type="text"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleChange}
                                        required
                                        className='check-input'
                                        placeholder="Street address"
                                    />

                                    <div className="name-group">
                                        <div>
                                            <label className='check-label'>City*</label>
                                            <input
                                                type="text"
                                                name="city"
                                                value={formData.city}
                                                onChange={handleChange}
                                                required
                                                className='check-input'
                                                placeholder="City"
                                            />
                                        </div>
                                        <div>
                                            <label className='check-label'>Region*</label>
                                            <input
                                                type="text"
                                                name="region"
                                                value={formData.region}
                                                onChange={handleChange}
                                                required
                                                className='check-input'
                                                placeholder="Region/State"
                                            />
                                        </div>
                                    </div>

                                    <label className='check-label'>Zip / Postal code*</label>
                                    <input
                                        type="text"
                                        name="zip"
                                        value={formData.zip}
                                        onChange={handleChange}
                                        required
                                        className='check-input'
                                        placeholder="000000"
                                    />

                                    {/* <button type="submit" className="checkout-button">Continue to Shipment</button> */}
                                    <button type="submit" className="checkout-button">PLACE ORDER</button>

                                </form>
                            </div>
                        </div>

                        {/* Right - Cart Summary with Customize Details */}
                        <div className="checkout-child checkout-right">
                            <div className="order-summary-card">
                                <div className="summary-header-new">
                                    <h3 className="summary-title">Items in your order ({cartData.length})</h3>
                                    <button className="edit-cart-link" onClick={openCart}>Edit Cart</button>
                                </div>

                                {cartData.length === 0 ? (
                                    <p className="empty-cart-msg">Your cart is empty.</p>
                                ) : (
                                    <>
                                        <div className="order-items-container">
                                            {cartData.map((item, index) => {
                                                const customize = customizeData2?.[0]?.find(c => c.Product_Id === item.Product_Id);

                                                return (
                                                    <div key={index} className="order-item-card">
                                                        <img
                                                            src={`${process.env.REACT_APP_IMAGE_BASE_URL}${item.Product_Img}`}
                                                            alt={item.Product_Name}
                                                            className="order-product-img"
                                                        />
                                                        <div className="order-product-info">
                                                            <h4 className="product-title">{item.Product_Name}</h4>
                                                            <p className="product-quantity">Quantity: {item.Quantity}</p>

                                                            {/* Customize Details */}
                                                            {customize && (customize.custom_description || customize.custom_size) && (
                                                                <div className="customize-details">
                                                                    {customize.custom_description && customize.custom_description.trim() !== "" && (
                                                                        <p className="custom-desc">
                                                                            <span className="custom-label">Custom Desc:</span> {customize.custom_description}
                                                                        </p>
                                                                    )}
                                                                    {customize.custom_size && customize.custom_size.trim() !== "" && (
                                                                        <p className="custom-size">
                                                                            <span className="custom-label">Custom Size:</span> {customize.custom_size}
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>

                                        <div className="checkout-actions-container">
                                            <button className="action-btn whatsapp-checkout-btn" onClick={handleWhatsAppCheckout}>
                                                CHECKOUT TO WHATSAPP
                                            </button>
                                            {/* <button className="action-btn place-order-checkout-btn" onClick={handlePlaceOrder}>
                                                PLACE ORDER
                                            </button> */}
                                        </div>


                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Checkout;